import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import { APIURL } from "./../../constants";
import services from "./../../components/services";
import { DefaultLayout } from "../../layouts";
import Image from "next/image";
import Head from 'next/head'
import { blogPathSlug } from '../../utils/blogUrls'

// class Blog extends React.Component {
export default function Blog({ data }) {
	let parsed = JSON.parse(data);
	let blog_posts = [];
	if (parsed) {
		for (const post in parsed) {
			const blog_post = parsed[post];
			const blog_image = blog_post["image"]
				? blog_post["image"]
				: "/no-image.png";
			const pathSlug = blogPathSlug(blog_post["title"]);
			blog_posts.push(
				<Link
					className="blog-card"
					key={"blog-post-" + post}
					title={blog_post["title"]}
					href={{
						pathname: `/blog/${pathSlug}`,
					}}
				>
					<Image
						src={blog_image}
						width={300}
						height={150}
						// classNames=''
						alt={blog_post["title"]}
						placeholder={"blur"}
						blurDataURL={blog_image}
					/>
					<div className="blog-title">{blog_post["title"]}</div>
					<div className="blog-created">{blog_post["created_at"]}</div>
				</Link>
			);
		}
	}
	// render () {
	return (
		<div className="home">
      <Head>
        <title>SimplyBuy | Snowboard, Ski & Product Guides</title>
        <meta name='description' content={"Guides that feed SimplyBuy’s product pickers — snowboards, skis, headphones, TVs, and more. Learn the tradeoffs, then get a personalized recommendation in minutes."}/>
      </Head>
			<div className="home-container">
				<h1 className="blog-index-title">SimplyBuy Blog</h1>
				<div className="blog-index">{blog_posts}</div>
			</div>
		</div>
	);
	// }
}

export async function getServerSideProps() {
	const response = await services.get_v2(APIURL.GET_BLOG_POSTS, { params: {} });
	const data = JSON.stringify(response);
	return { props: { data } };
}

// export default Blog
